export const invId = (inv) =>
  inv?.id || inv?.invoice_id || inv?._id || inv?.invoiceId || "";

export const eur = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(
    Number(n) || 0,
  );

export const normalizeList = (data) =>
  Array.isArray(data)
    ? data
    : data?.invoices || data?.items || data?.results || [];

export const statusOf = (inv) =>
  (inv?.status || inv?.pdp_status || "draft").toString().toLowerCase();

const STATUS_MAP = {
  draft: { label: "Brouillon", cls: "bg-zinc-500/15 text-zinc-300 border-zinc-500/30" },
  imported: { label: "Importée", cls: "bg-zinc-500/15 text-zinc-300 border-zinc-500/30" },
  converted: { label: "Convertie", cls: "bg-[#2563EB]/15 text-[#7FA6FF] border-[#2563EB]/40" },
  sent: { label: "Envoyée PDP", cls: "bg-[#00D4FF]/10 text-[#00D4FF] border-[#00D4FF]/30" },
  validated: { label: "Validée PDP", cls: "bg-[#34C759]/15 text-[#34C759] border-[#34C759]/40" },
  accepted: { label: "Acceptée", cls: "bg-[#34C759]/15 text-[#34C759] border-[#34C759]/40" },
  paid: { label: "Payée", cls: "bg-[#34C759]/15 text-[#34C759] border-[#34C759]/40" },
  refused: { label: "Refusée", cls: "bg-[#FF3B30]/15 text-[#FF3B30] border-[#FF3B30]/40" },
  rejected: { label: "Rejetée", cls: "bg-[#FF3B30]/15 text-[#FF3B30] border-[#FF3B30]/40" },
  received: { label: "Reçue", cls: "bg-[#A78BFA]/15 text-[#A78BFA] border-[#A78BFA]/40" },
  error: { label: "Erreur", cls: "bg-[#FF3B30]/15 text-[#FF3B30] border-[#FF3B30]/40" },
};

export const statusMeta = (status) =>
  STATUS_MAP[status] || {
    label: status ? status.charAt(0).toUpperCase() + status.slice(1) : "—",
    cls: "bg-zinc-500/15 text-zinc-300 border-zinc-500/30",
  };

export const isDomTom = (inv) =>
  Number(inv?.total_octroi) > 0 ||
  ["gp", "mq", "gf", "re", "yt", "guadeloupe", "martinique", "guyane", "réunion", "reunion", "mayotte"].includes(
    (inv?.region || "").toString().toLowerCase(),
  );

export const fmtDate = (d) => {
  if (!d) return "—";
  const dt = new Date(d);
  return Number.isNaN(dt.getTime())
    ? String(d)
    : dt.toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
};
